'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimarySummaryEditor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _utilsLocalization = require('@bibliocommons/utils-localization');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseLoader = require('@bibliocommons/base-loader');

var _baseLoader2 = _interopRequireDefault(_baseLoader);

var _baseAlerts = require('@bibliocommons/base-alerts');

var _baseIcons = require('@bibliocommons/base-icons');

var _loginLink = require('../../login-link');

var _loginLink2 = _interopRequireDefault(_loginLink);

var _simpleUgcForm = require('../../simple-ugc-form');

var _simpleUgcForm2 = _interopRequireDefault(_simpleUgcForm);

var _simpleUgcPermalink = require('../../simple-ugc-permalink');

var _simpleUgcPermalink2 = _interopRequireDefault(_simpleUgcPermalink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrimarySummaryEditor = exports.PrimarySummaryEditor = function (_BcReactComponent) {
  _inherits(PrimarySummaryEditor, _BcReactComponent);

  function PrimarySummaryEditor() {
    _classCallCheck(this, PrimarySummaryEditor);

    return _possibleConstructorReturn(this, (PrimarySummaryEditor.__proto__ || Object.getPrototypeOf(PrimarySummaryEditor)).apply(this, arguments));
  }

  _createClass(PrimarySummaryEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {/* testing goodness */}
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          characterLimit = _props.characterLimit,
          handleChange = _props.handleChange,
          handleLogin = _props.handleLogin,
          handleSubmit = _props.handleSubmit,
          showForm = _props.showForm,
          user = _props.user,
          userContentId = _props.userContentId,
          summary = _props.summary,
          bibId = _props.bibId,
          isPrivate = _props.isPrivate,
          handlePrivacyToggle = _props.handlePrivacyToggle,
          initializingStatus = _props.initializingStatus;


      if (initializingStatus.status === 'pending') {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_baseLoader2.default, null)
        );
      }

      if (initializingStatus.status === 'failure') {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _baseAlerts.AlertFailure,
            null,
            _react2.default.createElement('span', { className: 'icon-ok' }),
            (0, _utilsLocalization.localizeFromKey)(initializingStatus, this.props.intl)
          )
        );
      }

      if (user.loggedIn) {
        if (showForm) {
          return _react2.default.createElement(
            'div',
            { className: 'cp-primary-summary-editor well clearfix' },
            _react2.default.createElement(_simpleUgcForm2.default, {
              placeholderText: 'summary_field_placeholder',
              submitButtonText: 'add_summary',
              formHeadingText: 'enter_a_summary',
              characterLimit: characterLimit,
              body: summary,
              ugcType: 'summary',
              handleChange: handleChange,
              handleSubmit: handleSubmit,
              isNew: true })
          );
        }

        return _react2.default.createElement(_simpleUgcPermalink2.default, {
          bibId: bibId,
          userContentId: userContentId,
          ugcType: 'summary',
          isPrivate: isPrivate,
          handlePrivacyToggle: handlePrivacyToggle });
      }

      return _react2.default.createElement(
        'div',
        { className: 'well' },
        _react2.default.createElement(
          _loginLink2.default,
          { handleLogin: handleLogin },
          _react2.default.createElement(_baseIcons.Summary, null),
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'login_to_add_summary' })
        )
      );
    }
  }]);

  return PrimarySummaryEditor;
}(_baseBcReactComponent2.default);

PrimarySummaryEditor.propTypes = {
  initializingStatus: _react.PropTypes.shape({
    status: _react.PropTypes.string
  }).isRequired,
  characterLimit: _react.PropTypes.number,
  summary: _react.PropTypes.string,
  handleCancel: _react.PropTypes.func.isRequired,
  handleChange: _react.PropTypes.func.isRequired,
  handleLogin: _react.PropTypes.func.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  bibId: _react.PropTypes.string.isRequired,
  isPrivate: _react.PropTypes.bool.isRequired,
  handlePrivacyToggle: _react.PropTypes.func.isRequired,
  showForm: _react.PropTypes.bool.isRequired,
  user: _react.PropTypes.shape({
    loggedIn: _react.PropTypes.bool
  }).isRequired,
  userContentId: _react.PropTypes.number,
  intl: _reactIntl.intlShape
};

exports.default = (0, _reactIntl.injectIntl)(PrimarySummaryEditor);


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/primary-summary-editor/components/PrimarySummaryEditor.js
// module id = 1038
// module chunks = 4